/*
 * @Date: 2024-03-14 10:47:18
 * @LastEditors: fangdong dong.fang@quvideo.com
 * @LastEditTime: 2024-03-15 17:45:09
 * @FilePath: /video-marketing/services/assets.ts
 */
import { ListTypeValueType } from '@/utils/const';
import request from '@/utils/request';

import { ApiResult } from '.';
import { fetchUsedSeats } from './voices';
import { queryRight } from './workspace';

export type VideoRsDataType = {
  createTime: number;
  duration: number;
  fileUrl: string;
  id: number;
  taskType: number;
  title: string;
  type: number;
  cover?: string;
  customType?: string; // 7 字幕擦除
};

type VideoRqDataType = {
  /**
   * 1-文件夹，2-图片，3-视频，4-字体,5-音频,6- 音色音频 ，7- zip 文件,8-文本
   */
  type: number;
  pageNum: number;
  pageSize: number;
  /**
    VIDEO_MAKE(1, "视频制作"),
    AUDIO_MAKE(2, "音频制作"),
    VIDEO_TRAIN(3, "视频训练"),
    AUDIO_TRAIN(4, "音频训练"),
    VIDEO_EXPORT(5, "视频导出"),
    VIDEO_TRANSLATE(6, "视频翻译"),
    CAPTION_CLEAROFF(7, "字幕擦除"),
    VIDEO_SUBMIT_EXPORT(8, "营销视频导出"),
    QUICK_CLONE_TRAIN(9, "快速分身训练"),
    QUICK_CLONE_EXPORT(10, "快速分身导出");
   */
  customType?: string; // 7 字幕擦除
  sourceType?: number; // 文件来源类型，0-全部，1-用户上传的素材资产，2-剪辑合成后的资产，默认1
};

/**
 * 查询视频列表
 * @param id 片段id
 * @returns
 */
export const getVideoList = async <T>(data: VideoRqDataType): Promise<T> => {
  const res = await request('/api/rest/dlt/asset/query', {
    method: 'POST',
    data,
  });
  return res;
};

type TaskListRqType = {
  pageNum: number;
  pageSize: number;
  types: number[];
};

export type TaskListRsType = {
  id: number;
  taskId: string;
  state: number; // 状态，1-进行中，2-已完成，3-失败
  businessId: string;
  videoPreviewUrl: string;
  createTime: number;
  duration: number;
  videoUrl: string;
  /**
   * VIDEO_MAKE(1, "视频制作"),
    AUDIO_MAKE(2, "音频制作"),
    VIDEO_TRAIN(3, "视频训练"),
    AUDIO_TRAIN(4, "音频训练"),
    VIDEO_EXPORT(5, "视频导出"),
    VIDEO_TRANSLATE(6, "视频翻译"),
    CAPTION_CLEAROFF(7, "字幕擦除"),
    VIDEO_SUBMIT_EXPORT(8, "营销视频导出"),
    QUICK_CLONE_TRAIN(9, "快速分身训练"),
    QUICK_CLONE_EXPORT(10, "快速分身导出"),
    NEW_CLONE(11,"数字人训练+音色克隆"),
    LIP_SYNC(12,"lip-sync")
   */
  type: ListTypeValueType;
  videoTitle: string;
};

export const getTaskList = async <T>(params: TaskListRqType): Promise<T> => {
  const res = await request('/api/rest/dhc/task/list', {
    method: 'POST',
    data: params,
  });
  return res;
};

export interface IDeleteVideo {
  ids: number[];
}

/**
 * 重命名数字人
 */
export const renameAvatar = (params: {
  id: number;
  title: string;
}): Promise<ApiResult<string>> => {
  return new Promise(async (resolve, reject) => {
    const res = await request('/api/rest/dhc/template/personal/update', {
      method: 'POST',
      data: params,
    });
    if (res.isError) {
      reject(res);
    } else {
      resolve(res);
    }
  });
};
/**
 * 删除视频
 * @param params
 * @returns
 */
export const deleteVideo = async (params: IDeleteVideo) => {
  const res = await request('/api/rest/dlt/asset/del', {
    method: 'POST',
    data: params,
  });
  return res;
};
/**
 * 删除数字人任务
 */
export const deleteAvatarTask = async (params: IDeleteVideo) => {
  const res = await request('/api/rest/dhc/template/personal/del', {
    method: 'POST',
    data: params,
  });
  return res;
};

/**
 * 获取数字人的席位
 */
export const fetchAvatarSeats = async () => {
  const seat = {
    available: 0,
    total: 0,
    used: 0,
  };
  const getUsedSeats = () => fetchUsedSeats({ type: 1 });
  const getTotalSeats = () => queryRight();

  try {
    const res = await Promise.allSettled([getTotalSeats(), getUsedSeats()]);

    if (res[0].status === 'fulfilled') {
      const target = res[0].value.data.find(
        (item: any) => item.key === 'maxDigitalClone',
      );
      seat.total = target?.leftValue || 0;
    }

    if (res[1].status === 'fulfilled') {
      seat.used = res[1].value.data.count;
      seat.available = seat.total - res[1].value.data.count;
    }
    return seat;
  } catch (error) {
    return {
      available: 0,
      total: 0,
      used: 0,
    };
  }
};
